<template>
  <v-card>
    <v-toolbar color="error" class="mb-4" dark
      >Πρόβλημα
      <v-btn
        depressed
        icon
        class="ml-auto"
        color="white"
        @click="$emit('close')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="pa-4">
      <div
        class="d-flex align-center justify-center text-body-1 black--text mb-4"
      >
        <v-icon color="error" class="mr-1">mdi-alert-circle-outline</v-icon>
        <div >
          <strong>{{ this.data }}</strong> ;
        </div>
      </div>
      <div class="d-flex justify-center pb-2">
        <v-btn dense outlined color="error" class="mr-4" @click="$emit('close')"
          >Οκ</v-btn
        >
      </div>
    </v-card-text>
  </v-card>
</template>


<script>
export default {
  name: "ErrorModal",
  props: ["data"],
  data() {
    return {};
  },
  methods: {},
};
</script>